/**
 * Site Management's fill of Admin Home's hook (GW-19): the signed-in person's most used links,
 * from their click counts, and their section order.
 */
export const adminHomeLayout = () =>
  import('./AdminHomeLayout').then((module) => module.AdminHomeLayout)
